import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilePreviewTypeListMap } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { WorkFlowInfo } from 'src/app/modules/shared/models/form/work-flow-info.model';
import { WorkReportDocType } from 'src/app/modules/shared/models/form/work-report-doc-type.enum';
import { WorkReportStatus } from 'src/app/modules/shared/models/form/work-report-status.enum';
import { JgPhysicalInspReportFile } from 'src/app/modules/shared/models/jg/jg-physical-insp-report-file.model';
import { JgPhysicalInspUnitFb } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fb.model';
import { JgPhysicalInspUnitFxItemForm } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item-form.model';
import { JgPhysicalInspUnitItemProgress } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-progress.model';
import {
  ProjectSectionUnitJgStatusColorMap,
  ProjectSectionUnitJgStatusMap,
} from 'src/app/modules/shared/models/jg/project-section-unit-jg-status.enum';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import {
  ProjectSectionUnitStatusColorMap,
  ProjectSectionUnitStatusMap,
} from 'src/app/modules/shared/models/project/project-section-unit-status.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { JgPhysicalInspReportFileService } from 'src/app/modules/shared/services/jg-physical-insp-report-file.service';
import { JgPhysicalInspUnitFbService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fb.service';
import { JgPhysicalInspUnitFxItemFormService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fx-item-form.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { WorkFlowUserService } from 'src/app/modules/shared/services/work-flow-user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-insp-entity-report',
  templateUrl: './handover-insp-entity-report.component.html',
  styleUrls: ['./handover-insp-entity-report.component.scss'],
})
export class HandoverInspEntityReportComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  recordList: JgPhysicalInspUnitFxItemForm[] = [];

  sectionList: ProjectSection[] = [];

  isLM = false;

  record: JgPhysicalInspReportFile = new JgPhysicalInspReportFile();

  recordTable: JgPhysicalInspUnitItemProgress[] = [];
  recordFakeTable: JgPhysicalInspUnitItemProgress[] = [];

  ProjectSectionUnitJgStatusMap = ProjectSectionUnitJgStatusMap;

  ProjectSectionUnitJgStatusColorMap = ProjectSectionUnitJgStatusColorMap;

  ProjectSectionUnitStatusMap = ProjectSectionUnitStatusMap;

  ProjectSectionUnitStatusColorMap = ProjectSectionUnitStatusColorMap;

  sectionId: number;

  jgSectionId: number;

  jgPhysicalInspUnitFbList: JgPhysicalInspUnitFb[] = [];

  jgFbCascaderOptions: NzTreeNode[] = [];

  jgFbCascaderValue: any[] = [];

  checkAll = false;

  FilePreviewTypeListMap = FilePreviewTypeListMap;
  FileType = FileType;

  currentFile: FileResponse;

  environment = environment;

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  height = 0;
  width = 0;
  recordListHeight = 0;

  pdfZoom = 1;
  pdfPages = 1;
  pdfTotal = 0;

  WorkReportDocType = WorkReportDocType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private jgPhysicalInspReportFileService: JgPhysicalInspReportFileService,
    private projectSectionService: ProjectSectionService,
    private workFlowUserService: WorkFlowUserService,
    private jgPhysicalInspUnitFbService: JgPhysicalInspUnitFbService,
    private jgPhysicalInspUnitFxItemFormService: JgPhysicalInspUnitFxItemFormService,
    private globalService: GlobalService,
  ) {
    this.jgSectionId = this.activatedRoute.snapshot.params['jgSectionId'];
    this.sectionId = this.activatedRoute.snapshot.params['sectionId'];
    this.currentFile = this.globalService.getArchiveReportCache()!;
  }

  onCheckChange() {
    this.checkAll = this.recordList.every((item) => item.checked);
  }

  onCheckAllChange() {
    for (let index = 0; index < this.recordList.length; index++) {
      this.recordList[index].checked = this.checkAll;
    }
  }

  ngAfterViewInit(): void {
    window.addEventListener('resize', () => {
      this.resize();
    });
    setTimeout(() => {
      this.resize();
    }, 50);
  }

  resize() {
    this.height = document.body.clientHeight;
    this.recordListHeight = Math.max(this.height - 350, 0);
  }

  onPageLoad(event: any) {
    console.log(event);
    this.pdfTotal = event.source.pdfDocument._pdfInfo.numPages;
    this.resize();
  }

  prePage() {
    if (this.pdfPages > 1) {
      this.pdfPages--;
    }
  }

  nextPage() {
    if (this.pdfPages < this.pdfTotal) {
      this.pdfPages++;
    }
  }

  originSize() {
    this.pdfZoom = 1;
  }

  zoomIn() {
    this.pdfZoom += 0.1;
    if (this.pdfZoom > 2) {
      this.pdfZoom = 2;
    }
  }

  zoomOut() {
    this.pdfZoom -= 0.1;
    if (this.pdfZoom < 0.5) {
      this.pdfZoom = 0.5;
    }
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  ngOnInit(): void {
    this.getJgFb();
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
      });
  }

  getJgFb() {
    this.jgPhysicalInspUnitFbService
      .findAll({
        sectionId: this.sectionId,
        projectId: this.globalService.projectId,
        jgSectionId: this.jgSectionId,
      })
      .subscribe((res: JgPhysicalInspUnitFb[]) => {
        this.jgPhysicalInspUnitFbList = res.sort((a, b) => {
          if (a.dwCodeSort === b.dwCodeSort) {
            if (a.dwTypeNameSort === b.dwTypeNameSort) {
              return a.jgFbNameSort! - b.jgFbNameSort!;
            }
            return a.dwTypeNameSort! - b.dwTypeNameSort!;
          }
          return a.dwCodeSort! - b.dwCodeSort!;
        });
        this.jgFbCascaderOptions = this.buildJgInspUnitFbTree(res);
      });
  }

  private buildJgInspUnitFbTree(
    jgFbList: JgPhysicalInspUnitFb[],
  ): NzTreeNode[] {
    const nodes: NzTreeNode[] = [];
    if (jgFbList.length === 0) {
      return nodes;
    }
    let lastDw = '';
    for (const item of jgFbList) {
      if (lastDw !== item.dwCode) {
        nodes.push({
          label: item.dwCode! + ' ' + item.dwName!,
          value: item.dwCode! + '#' + item.dwName!,
          children: [
            {
              label: item.jgFbName!,
              value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
              isLeaf: true,
            },
          ],
        });
      } else {
        nodes[nodes.length - 1].children!.push({
          label: item.jgFbName!,
          value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
          isLeaf: true,
        });
      }
      lastDw = item.dwCode!;
    }

    return nodes;
  }

  onFbCascaderValueChange() {
    const value = this.jgFbCascaderValue[this.jgFbCascaderValue.length - 1];
    const [dwCode, dwName, jgFbName, jgSectionId] = value.split('#');
    console.log(dwCode, dwName, jgFbName, jgSectionId);
    console.log(this.jgFbCascaderValue);
    this.jgPhysicalInspUnitFxItemFormService
      .findAll({
        projectId: this.globalService.projectId,
        jgSectionId,
        sectionId: this.sectionId,
        dwCode,
        jgFbName,
      })
      .subscribe((res: JgPhysicalInspUnitFxItemForm[]) => {
        this.recordList = res;
      });
  }

  getColor(status: string) {
    switch (status) {
      case WorkReportStatus.DRAFT:
        return '#000000';
      case WorkReportStatus.FINISH:
        return '#2b58cd';
      case WorkReportStatus.WAIT_SIGN:
      case WorkReportStatus.WAIT_SEAL:
        return '#A30014';
      case WorkReportStatus.REJECT_SIGN:
      case WorkReportStatus.REJECT_SEAL:
      case WorkReportStatus.CANCLE:
        return '#FF0000';
      default:
        return '#BDC3C7';
    }
  }

  reports(workFlowId: number) {
    this.workFlowUserService
      .getWorkFlowInfo(workFlowId)
      .subscribe((response: WorkFlowInfo) => {
        if (response) {
          this.sign(response.workFlowKey!);
        }
      });
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  // searchRecord() {
  // this.jgPhysicalInspUnitItemProgressService
  //   .findAll<JgPhysicalInspUnitItemProgressSearchRequest>({
  //     projectId: this.globalService.projectId,
  //     jgSectionId: this.fxItem?.jgSectionId,
  //     sectionId: this.fxItem?.sectionId,
  //     dwCode: this.fxItem?.dwCode,
  //     jgFbName: this.fxItem?.jgFbName,
  //     jgFxName: this.fxItem?.jgFxName,
  //     jgFxProjectTypeCode: this.fxItem?.jgFxProjectTypeCode,
  //     jgInspItemCode: this.fxItem?.jgInspItemCode,
  //     sectionItemType: this.isLM
  //       ? ProjectItemType.SEGMENT
  //       : ProjectItemType.SECTION,
  //   })
  //   .subscribe((data: JgPhysicalInspUnitItemProgress[]) => {
  //     this.recordList = data ?? [];
  //     if (!this.isLM) {
  //       for (const item of this.recordList) {
  //         item.sectionCode = item.code;
  //         item.sectionName = item.name;
  //       }
  //     }
  //   });
  // }

  cancel() {
    window.close();
  }

  get canConfirm() {
    if (
      !this.record.fileFinishDateDate ||
      !this.record.fileSn ||
      this.jgFbCascaderValue.length < 2
    ) {
      return false;
    }
    const checkedCount = this.recordList.filter((item) => item.checked).length;
    if (checkedCount === 0) {
      return false;
    }
    return true;
  }

  confirm() {
    this.jgPhysicalInspReportFileService
      .create(this.buildReq())
      .subscribe((resp) => {
        if (resp) {
          window.close();
        }
      });
    //   .batchInsp(this.buildReq())
    //   .subscribe((res) => {
    //     this.sign(res.workFlowKey!);
    //   });
  }

  private buildReq(): JgPhysicalInspReportFile {
    const req = new JgPhysicalInspReportFile();
    req.projectId = this.globalService.projectId;
    req.sectionId = this.sectionId;
    req.jgSectionId = this.jgFbCascaderValue[1].split('#')[3];
    req.dwCode = this.jgFbCascaderValue[1].split('#')[0];
    req.jgFbName = this.jgFbCascaderValue[1].split('#')[2];
    if (this.record.fileFinishDateDate) {
      req.fileFinishDate = new Date(this.record.fileFinishDateDate).getTime();
    }
    if (this.record.fileSubmitDateDate) {
      req.fileSubmitDate = new Date(this.record.fileSubmitDateDate).getTime();
    }
    req.fileSn = this.record.fileSn;
    req.fileId = this.currentFile.fileId;
    req.fileName = this.currentFile.fileName;
    req.fileMd5 = this.currentFile.fileMd5;
    req.jgRfiIds = this.recordList
      .filter((item) => item.checked)
      .map((item) => item.id!);
    return req;
  }
}
